/* eslint-disable no-use-before-define */
import React from 'react'

export const NotFound = () => {
    return <div data-name="loading-fail" className="row">
    <div className="col-md-12 text-center">
        <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
        <div className="small-header">Data not found.</div>
    </div></div>
}